import { gql } from 'apollo-boost'

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($input: RecoverPasswordInput!) {
    recoverPassword(input: $input) {
      message
    }
  }
`
